// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MK6V","badges":"styles_badges__3u5lo"};